import { Store } from "lucide-react";
import { EmptyResourceState } from "@/components/custom/resources/empty-resource-state";

type CatalogEmptyStateProps = {
  /** True when entries exist but none match the active search. */
  isFiltered: boolean;
  /** Opens the create sheet, which is owned by the list so it outlives this subtree. */
  onCreate: () => void;
};

export const CatalogEmptyState = ({
  isFiltered,
  onCreate,
}: CatalogEmptyStateProps) => {
  if (isFiltered) {
    return (
      <EmptyResourceState
        description="No published tools match your search criteria."
        resourceType="matching tools"
      />
    );
  }

  return (
    <EmptyResourceState
      actionLabel="Add grant"
      description="Publish tools here so your end-users can self-serve them — grant a tool to a specific IdP group, or to everyone."
      icon={Store}
      onAction={onCreate}
      resourceType="published tools"
      title="No end-user tools published yet"
    />
  );
};
